<template>
  <footer>
    <div class="foot_content">
      <div class="left">
        <div class="contact">联系我们</div>
        <div class="list phone">
          <img src="@/assets/img/index/dh-icon.png" alt="" />
          <span>电话：</span>
          <span>0551-65708063</span>
        </div>
        <div class="list">
          <img src="@/assets/img/index/yx-icon.png" alt="" />
          <span>邮箱：support@ct-sec.com</span>
        </div>

        <div class="list">
          <img src="@/assets/img/index/dz-icon.png" alt="" />
          <span>地址：合肥市包河经济开发区南淝河路与兰州路交口中关村协同创新智汇园A1栋4-5楼</span>
        </div>
      </div>
      <!-- <div class="right">
        <img src="@/assets/img/index/ahzx-icon.png" alt="" />
        <div>微信公众号</div>
      </div> -->
    </div>
    <div class="foot_desc">
      <p class="desc">版权所有: 安徽数安系统集成有限公司</p>
      <!-- <p class="desc">皖公网安备 458466400006466号</p> -->
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
// @media (max-width: 1366px) {
//   .foot_content {
//     min-width: 1100px;
//     max-width: 1100px;
//   }
// }
// @media (min-width: 1366px) {
//   .foot_content {
//     min-width: 1200px;
//     max-width: 1200px;
//   }
// }
// @media (min-width: 1600px) {
//   .foot_content {
//     min-width: 1440px;
//     max-width: 1440px;
//   }
// }
.custor {
  cursor: pointer;
}

//@media screen and (min-width: 0px) {
//  .foot_content {
//    min-width: 1200px;
//    max-width: 1200px;
//  }
//}
//@media screen and (min-width: 1600px) {
//    .foot_content {
//      min-width: 1440px;
//      max-width: 1440px;
//    }
//}
footer {
  //width: 100%;
  // height: 278px;
  background-color: #f8f8fa;
  // border-bottom: 1px solid #17181c;
}

span {
  font-size: 12px;
  color: white;
  //cursor: pointer;
}

.foot_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(112, 112, 112, 0.23);
  align-items: flex-start;
  padding: 30px 0 20px;

  .left {
    .contact {
      font-weight: bold;
      font-size: 16px;
      color: #303030;
      padding-bottom: 25px;
    }

    .list {
      display: flex;
      align-items: center;
      padding-bottom: 15px;

      span {
        color: #4e4e4e;
        font-size: 14px;

        &:nth-child(2) {
          padding-left: 8px;
        }
      }
    }

    .phone {
      align-items: flex-end;

      span {
        color: #4e4e4e;
        font-size: 14px;

        &:nth-child(3) {
          font-size: 18px;
          font-family: math;
          font-weight: bold;
        }
      }
    }
  }

  .right {
    text-align: center;

    img {
      width: 122px;
    }

    div {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
}

.tel {
  color: #1ac6a0 !important;
  font-size: 24px;
}

.tel_text {
  margin-bottom: 5px;
  margin-top: -3px;
}

.foot_desc {
  width: 100%;
  height: calc(100% - 230px);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 45px;
  color: #767676;

  .desc {
    font-size: 12px;
    color: #767676;
    margin-bottom: 0px;
    margin-top: 0px;
    // height: 10px;
  }
}

.icons {
  margin-left: 6px;
  cursor: context-menu;
}

.font_color {
  color: #ccced3;
}

.font_color:hover {
  color: #fff;
}

.font_colorDry {
  color: #ccced3;
}

i {
  cursor: context-menu;
}

.noHover,
.noHover:hover {
  color: #ccced3;
  cursor: context-menu;
}

.color_fff {
  color: #fff !important;
}
</style>
